/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Woman Reading', 'sticker name', 'web-stories');

function Woman({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 43 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M20.9318 2.84781C20.9318 4.42062 19.6872 5.69563 18.1518 5.69563C16.6165 5.69563 15.3718 4.42062 15.3718 2.84781C15.3718 1.27501 16.6165 0 18.1518 0C19.6872 0 20.9318 1.27501 20.9318 2.84781Z"
        fill="#D898A9"
      />
      <path
        d="M16.1855 5.01774C16.1855 6.59054 14.9409 7.86555 13.4055 7.86555C11.8701 7.86555 10.6255 6.59054 10.6255 5.01774C10.6255 3.44493 11.8701 2.16992 13.4055 2.16992C14.9409 2.16992 16.1855 3.44493 16.1855 5.01774Z"
        fill="#D898A9"
      />
      <path
        d="M26.4919 13.0187C26.4919 14.5915 25.2472 15.8665 23.7119 15.8665C22.1765 15.8665 20.9319 14.5915 20.9319 13.0187C20.9319 11.4459 22.1765 10.1709 23.7119 10.1709C25.2472 10.1709 26.4919 11.4459 26.4919 13.0187Z"
        fill="#D898A9"
      />
      <path
        d="M23.644 4.06803C23.644 5.64083 22.3994 6.91584 20.864 6.91584C19.3286 6.91584 18.084 5.64083 18.084 4.06803C18.084 2.49522 19.3286 1.22021 20.864 1.22021C22.3994 1.22021 23.644 2.49522 23.644 4.06803Z"
        fill="#D898A9"
      />
      <path
        d="M28.6616 14.5104C28.6616 16.0832 27.4169 17.3582 25.8816 17.3582C24.3462 17.3582 23.1016 16.0832 23.1016 14.5104C23.1016 12.9376 24.3462 11.6626 25.8816 11.6626C27.4169 11.6626 28.6616 12.9376 28.6616 14.5104Z"
        fill="#D898A9"
      />
      <path
        d="M25.4072 7.18717C25.4072 8.75997 24.1625 10.035 22.6272 10.035C21.0918 10.035 19.8472 8.75997 19.8472 7.18717C19.8472 5.61437 21.0918 4.33936 22.6272 4.33936C24.1625 4.33936 25.4072 5.61437 25.4072 7.18717Z"
        fill="#D898A9"
      />
      <path
        d="M17.5415 8.40787C17.5415 9.98068 16.2968 11.2557 14.7615 11.2557C13.2261 11.2557 11.9814 9.98068 11.9814 8.40787C11.9814 6.83507 13.2261 5.56006 14.7615 5.56006C16.2968 5.56006 17.5415 6.83507 17.5415 8.40787Z"
        fill="#D898A9"
      />
      <path
        d="M17.8127 3.66178C17.8127 5.23458 16.5681 6.50959 15.0327 6.50959C13.4973 6.50959 12.2527 5.23458 12.2527 3.66178C12.2527 2.08897 13.4973 0.813965 15.0327 0.813965C16.5681 0.813965 17.8127 2.08897 17.8127 3.66178Z"
        fill="#D898A9"
      />
      <path
        d="M24.3222 11.2555C24.3222 12.8283 23.0776 14.1033 21.5422 14.1033C20.0069 14.1033 18.7622 12.8283 18.7622 11.2555C18.7622 9.68272 20.0069 8.40771 21.5422 8.40771C23.0776 8.40771 24.3222 9.68272 24.3222 11.2555Z"
        fill="#D898A9"
      />
      <path
        d="M26.0849 9.35709C26.0849 10.9299 24.8403 12.2049 23.3049 12.2049C21.7696 12.2049 20.5249 10.9299 20.5249 9.35709C20.5249 7.78429 21.7696 6.50928 23.3049 6.50928C24.8403 6.50928 26.0849 7.78429 26.0849 9.35709Z"
        fill="#D898A9"
      />
      <path
        d="M19.9826 15.4596C19.9826 17.0324 18.738 18.3075 17.2026 18.3075C15.6673 18.3075 14.4226 17.0324 14.4226 15.4596C14.4226 13.8868 15.6673 12.6118 17.2026 12.6118C18.738 12.6118 19.9826 13.8868 19.9826 15.4596Z"
        fill="#D898A9"
      />
      <path
        d="M18.7622 12.4762C18.7622 14.049 17.5175 15.324 15.9822 15.324C14.4468 15.324 13.2021 14.049 13.2021 12.4762C13.2021 10.9034 14.4468 9.62842 15.9822 9.62842C17.5175 9.62842 18.7622 10.9034 18.7622 12.4762Z"
        fill="#D898A9"
      />
      <path
        d="M5.95175 33.6516C5.95175 33.6516 0.179661 33.5237 0.00930023 35.8584C-0.205364 38.8002 3.35923 43.1193 10.4103 43.6834C15.5632 44.097 26.3339 43.8427 26.3339 43.8427C26.3339 43.8427 38.4624 41.3075 41.0531 38.0799C43.8625 34.5797 42.2415 29.4807 35.6277 29.7722C29.0139 30.0638 23.2554 33.6516 23.2554 33.6516H5.95175Z"
        fill="#558BBA"
      />
      <path
        d="M14.3671 17.8873C14.3671 17.8873 18.7213 16.0888 20.168 15.5231C21.6147 14.9591 25.9356 14.3569 26.945 14.7531C27.9559 15.1492 25.9103 33.3548 24.8645 34.174C23.8188 34.9932 13.4733 33.835 13.4733 33.835L14.3671 17.8873Z"
        fill="#4A7F9B"
      />
      <path
        d="M41.6203 50L0.325195 50L0.325195 43.8429L41.6203 43.8429V50Z"
        fill="#B4433B"
      />
      <path
        d="M21.3644 12.5439L21.9332 15L23.0429 14.862C23.0429 14.862 23.8869 21.4553 20.3899 22.8798C16.8073 24.3391 16.1949 20.8498 16.7796 16.6667L18.0654 15.8762L17.6534 13.6246L21.3644 12.5439Z"
        fill="#CF6450"
      />
      <path
        d="M14.9237 30.942C14.8343 31.9227 14.9908 33.9682 13.1204 34.4546C11.6301 34.8428 9.0664 34.5196 9.13508 30.8343C9.1862 28.144 11.0455 21.2186 11.7595 19.3664C13.6698 14.4057 15.0451 12.308 15.8581 13.0178C16.6712 13.726 18.6502 14.9793 18.318 16.0772C18.1423 16.6555 15.8358 15.0807 15.6377 14.6275C15.2655 13.7751 17.5449 16.8837 16.8149 17.8882C16.085 18.8927 13.7445 19.3664 13.7445 19.3664C13.7445 19.3664 15.1889 28.0156 14.9237 30.942Z"
        fill="#CF6450"
      />
      <path
        d="M5.06533 26.5117L12.7206 29.1037L21.9314 26.7697L27.9114 30.2715L15.8579 33.3566L10.1283 32.3076L5.06533 26.5117Z"
        fill="#DA9BB2"
      />
      <path
        d="M12.6877 4.08219C13.0489 2.23464 15.6507 1.04466 16.2354 1.03516C16.6625 1.04089 17.5954 1.08949 17.9102 1.23797C18.8229 1.19678 21.2203 2.09203 21.7036 3.60842C22.1869 5.1248 21.8969 7.84859 22.0522 8.25899C22.2074 8.66938 14.3752 10.2222 13.6304 8.94983C12.8857 7.67746 12.1664 6.74577 12.6877 4.08219Z"
        fill="#D898A9"
      />
      <path
        d="M15.4683 4.31558C16.1813 7.03303 14.5286 9.58253 13.6302 8.9503L14.4225 10.7133C15.191 13.3801 17.1273 14.7417 19.1174 14.363C21.0743 13.9907 22.3047 12.0573 22.0845 9.35725L21.8571 7.55434C21.8571 7.55434 21.8523 7.55909 21.8428 7.56543C21.8428 7.56543 18.6769 8.33709 17.4648 7.74131C16.1971 7.11701 15.5079 4.29181 15.4683 4.31558Z"
        fill="#CF6450"
      />
      <path
        opacity="0.34"
        d="M12.8651 29.1035L22.0775 26.7695L28.0559 30.2713L16.0025 33.3564L12.8651 29.1035Z"
        fill="#DA9BB2"
      />
      <path
        d="M5.20237 26.3628L6.4215 25.4949L12.6859 28.0151L20.5451 25.2295L27.2334 29.0688L27.0591 29.7723L21.9316 26.7696L12.7208 29.1036L5.20237 26.3628Z"
        fill="white"
      />
      <g opacity="0.21">
        <path
          opacity="0.21"
          d="M16.183 30.3029C16.5871 29.7579 18.1684 28.777 17.3492 28.72C16.8406 28.6836 16.1434 29.9623 15.3543 30.707C15.3559 30.707 15.7948 30.6927 16.183 30.3029Z"
          fill="#F78E66"
        />
        <path
          opacity="0.21"
          d="M9.33637 31.033C9.21595 30.808 7.70432 30.0617 7.70432 30.0617C7.70432 30.0617 5.61433 29.2853 5.65712 29.3122C6.37332 29.7717 8.01647 30.7066 9.20169 31.3879C9.00521 31.3103 9.72775 31.7666 9.33637 31.033Z"
          fill="#F78E66"
        />
      </g>
      <path
        opacity="0.29"
        d="M26.5552 19.4728L25.69 22.1982C25.69 22.1982 25.2749 21.3283 25.3462 19.5758C25.4048 18.1133 25.9245 16.0376 25.9245 16.0376C25.9245 16.0376 25.6235 19.2098 25.9467 19.5758C26.1559 19.8119 26.5552 19.4728 26.5552 19.4728Z"
        fill="#CF6450"
      />
      <path
        d="M13.0874 28.7494L13.076 28.7447L5.76835 26.0945C5.74987 26.0883 5.73849 26.0647 5.7456 26.0444C5.75129 26.0224 5.77261 26.0114 5.7911 26.0193L13.0874 28.6647L20.8187 25.6304L23.082 26.9649C23.1005 26.9758 23.1062 26.9994 23.0977 27.0197C23.0877 27.0386 23.0664 27.0464 23.0479 27.037L20.813 25.7198L13.0874 28.7494Z"
        fill="#1E1E1E"
      />
      <path
        d="M17.7828 38.6758L19.2976 38.9277L18.5196 43.8889H16.3266L17.7828 38.6758Z"
        fill="#CF6450"
      />
      <path
        d="M23.4362 39.4475L24.9922 38.6362L27.3706 43.8889L26.0555 43.8715L23.4362 39.4475Z"
        fill="#CA553F"
      />
      <path
        d="M19.2976 38.9277L18.5196 43.8889C18.5196 43.8889 22.1434 43.7494 22.4286 44.2597C23.6091 46.3702 24.3681 48.9483 26.3266 48.3762C28.2834 47.8042 25.803 42.1974 25.2855 40.6438C24.6353 39.3311 19.2976 38.9277 19.2976 38.9277Z"
        fill="#CF6450"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9809 13.9605C16.3924 13.5558 15.7205 13.2012 15.2817 12.9987L15.3262 12.9023C15.769 13.1067 16.4464 13.4641 17.0411 13.873C17.3384 14.0775 17.6163 14.2957 17.8341 14.515C18.0509 14.7333 18.213 14.9575 18.2709 15.1744C18.3399 15.4333 18.3503 15.6376 18.3148 15.7922C18.2789 15.9485 18.1957 16.0543 18.0815 16.109C17.969 16.1627 17.8343 16.1632 17.7001 16.126C17.5654 16.0887 17.4273 16.0124 17.3036 15.9064L17.3727 15.8258C17.4863 15.9233 17.6109 15.9911 17.7284 16.0237C17.8463 16.0564 17.9532 16.0527 18.0357 16.0132C18.1163 15.9746 18.1815 15.8982 18.2113 15.7684C18.2415 15.637 18.2349 15.4514 18.1683 15.2018C18.1177 15.0118 17.9713 14.8038 17.7588 14.5898C17.5473 14.3769 17.2752 14.1629 16.9809 13.9605Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7993 16.3914C16.5576 15.8036 16.1968 15.1932 15.9382 14.8109L16.0262 14.7515C16.2874 15.1377 16.6522 15.7545 16.8975 16.351C17.0201 16.6491 17.1139 16.9446 17.1491 17.2049C17.1842 17.4635 17.1628 17.6978 17.0422 17.8637L16.9563 17.8012C17.0527 17.6687 17.0777 17.4685 17.0439 17.2191C17.0104 16.9715 16.9203 16.6855 16.7993 16.3914Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3457 17.4313C16.0771 17.0536 15.7745 16.751 15.7411 16.7176L15.8162 16.6426L15.8162 16.6426C15.8508 16.6772 16.1584 16.9847 16.4322 17.3698C16.569 17.5622 16.6988 17.776 16.7816 17.986C16.8639 18.1951 16.9024 18.4077 16.8466 18.5939C16.8242 18.6685 16.7901 18.7268 16.7435 18.7677C16.6964 18.809 16.6402 18.8291 16.58 18.8329C16.4632 18.8403 16.3295 18.7866 16.199 18.709C15.9356 18.5524 15.65 18.2764 15.4678 18.0715L15.5471 18.0009C15.7265 18.2028 16.0037 18.4693 16.2533 18.6178C16.3794 18.6928 16.4898 18.7323 16.5733 18.727C16.6133 18.7244 16.6463 18.7117 16.6735 18.6879C16.7012 18.6635 16.7266 18.6245 16.7449 18.5634C16.7907 18.4106 16.7615 18.2249 16.6828 18.0249C16.6045 17.8261 16.48 17.6202 16.3457 17.4313Z"
        fill="black"
      />
      <path
        d="M30.1532 17.6293C29.7193 14.8629 27.3506 14.5781 26.2205 14.7815C22.7625 19.2566 25.7459 24.681 25.8137 27.3254C25.8815 29.9698 18.8976 30.58 18.2195 30.58C17.5415 30.58 17.2703 30.7157 18.0161 29.2917C18.6128 28.1526 17.6771 28.6363 17.1347 29.0205C16.5922 29.4274 15.9142 30.7835 13.4054 30.7835C10.8966 30.7835 10.761 31.7327 12.2527 32.004C13.7444 32.2752 23.8474 32.1396 27.6444 30.7835C31.4415 29.4274 30.6957 21.0874 30.1532 17.6293Z"
        fill="#CF6450"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.067 32.0129C14.1889 32.0185 14.2908 32.0281 14.3614 32.0458L14.3485 32.0972C14.2835 32.081 14.1862 32.0715 14.0645 32.066C13.9433 32.0604 13.7997 32.0588 13.6428 32.0578C13.6156 32.0576 13.588 32.0574 13.5601 32.0573C13.2663 32.0555 12.9346 32.0535 12.624 32.0302C12.2846 32.0047 11.9666 31.9537 11.7498 31.8474C11.641 31.7942 11.5554 31.7259 11.5062 31.6376C11.4567 31.5485 11.4462 31.4426 11.4816 31.3184L11.5327 31.3329C11.5004 31.4461 11.5111 31.5371 11.5526 31.6118C11.5946 31.6872 11.6699 31.7492 11.7731 31.7998C11.9801 31.9012 12.2892 31.9518 12.6279 31.9772C12.9366 32.0004 13.2665 32.0024 13.5606 32.0042C13.5885 32.0044 13.616 32.0045 13.6432 32.0047C13.8 32.0058 13.9445 32.0074 14.067 32.0129Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2078 12.1054C18.4792 12.89 17.5045 12.6642 17.1099 12.4553L17.1595 12.3614C17.5333 12.5593 18.4482 12.7674 19.13 12.0332L19.2078 12.1054Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6221 11.8391C17.5867 11.1667 17.5053 9.65251 17.4629 8.97342L17.5688 8.9668C17.6094 9.61626 17.6856 11.0281 17.7231 11.7389L18.4943 11.2087L18.5544 11.2962L17.6271 11.9338L17.6221 11.8391Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3675 9.63643C15.3442 9.6197 15.3268 9.60722 15.3159 9.60179L15.3634 9.50684C15.3839 9.51708 15.4107 9.53562 15.4434 9.55817C15.6164 9.67767 15.9525 9.90979 16.3708 9.61698L16.4317 9.70395C15.941 10.0474 15.523 9.74785 15.3675 9.63643Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6053 9.10567C18.582 9.08894 18.5646 9.07645 18.5537 9.07102L18.6012 8.97607C18.6217 8.98632 18.6485 9.00486 18.6812 9.02741C18.8542 9.14691 19.1903 9.37902 19.6086 9.08622L19.6695 9.17319C19.1788 9.51666 18.7608 9.21709 18.6053 9.10567Z"
        fill="black"
      />
    </svg>
  );
}

Woman.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 43 / 50,
  svg: Woman,
  title,
};
